import React from "react";

const OneGPIconShort = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 36 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8631 35.0577C20.9963 35.2466 19.2339 34.8058 18.5337 34.224C18.3192 34.0264 18.1744 33.7643 18.1216 33.4778C18.0356 33.0755 18.1744 32.6581 18.4847 32.3877C19.1325 31.9635 19.9247 31.821 20.6796 31.9933C21.3255 32.077 21.9759 32.1185 22.6274 32.1181C29.2195 32.1181 33.4773 28.1247 33.4773 21.9428C33.4773 15.761 29.2158 11.7649 22.6271 11.7649C16.0383 11.7649 11.7768 15.7598 11.7768 21.9421C11.7768 25.3857 13.0984 28.1496 15.4094 29.9233C14.296 30.5933 13.44 31.6189 12.9804 32.8345C12.5951 34.2191 13.0381 35.702 14.1199 36.6485L14.391 36.9116L14.0516 37.0825C11.5291 38.3505 10.312 40.1223 10.6223 42.074C10.6543 42.2681 10.7011 42.4593 10.7629 42.6459C11.89 46.5376 17.5451 48.1616 23.1229 47.9874C26.3147 47.8874 35.1525 46.5119 35.2446 41.011C35.3694 33.474 26.7619 34.6738 23.38 35.0101L22.8631 35.0577ZM22.6271 16.6715C25.3653 16.6715 27.0658 18.6922 27.0658 21.944C27.0658 25.1957 25.3653 27.2164 22.6271 27.2164C19.8889 27.2164 18.1864 25.1957 18.1864 21.944C18.1864 18.6922 19.887 16.6715 22.6271 16.6715ZM18.5111 39.0903C18.6427 39.0726 18.8188 39.0462 19.0292 39.0141C22.7262 38.4678 27.8052 37.9207 29.2282 39.5277C29.6136 39.9734 29.7312 40.5914 29.5359 41.1471C29.1238 42.6497 25.8818 43.3118 22.839 43.3118C22.0355 43.3133 21.2323 43.2643 20.4348 43.1644C17.9911 42.8462 16.6394 42.0932 16.63 41.0438C16.6043 39.9918 17.9259 39.1676 18.5137 39.088"
        fill="#262AFF"
      />
      <path
        d="M28.7296 7.35291C19.8051 4.0938 9.9364 8.69311 6.68744 17.6074C6.09857 19.2218 5.75336 20.9173 5.66198 22.6433C5.47923 26.2984 6.43361 29.923 8.42359 32.9994C9.23583 34.2583 8.87032 35.9336 7.61135 36.7458C6.37269 37.5378 4.73806 37.2027 3.90552 35.9945C-3.19142 25.3846 -0.34859 11.0283 10.2613 3.92119C12.2005 2.62161 14.3225 1.62665 16.5561 0.966702C21.257 -0.424257 26.2725 -0.312598 30.9125 1.29157H30.9226C32.5877 1.91091 33.4406 3.75876 32.8314 5.42385C32.2323 7.04833 30.4454 7.91133 28.8006 7.36307L28.7397 7.34278"
        fill="url(#paint0_linear_19627_4648)"
      />
      <path
        d="M28.7296 7.35291C19.8051 4.0938 9.9364 8.69311 6.68744 17.6074C6.09857 19.2218 5.75336 20.9173 5.66198 22.6433C5.47923 26.2984 6.43361 29.923 8.42359 32.9994C9.23583 34.2583 8.87032 35.9336 7.61135 36.7458C6.37269 37.5378 4.73806 37.2027 3.90552 35.9945C-3.19142 25.3846 -0.34859 11.0283 10.2613 3.92119C12.2005 2.62161 14.3225 1.62665 16.5561 0.966702C21.257 -0.424257 26.2725 -0.312598 30.9125 1.29157H30.9226C32.5877 1.91091 33.4406 3.75876 32.8314 5.42385C32.2323 7.04833 30.4454 7.91133 28.8006 7.36307L28.7397 7.34278"
        fill="url(#paint1_linear_19627_4648)"
      />
      <path
        d="M28.7296 7.35291C19.8051 4.0938 9.9364 8.69311 6.68744 17.6074C6.09857 19.2218 5.75336 20.9173 5.66198 22.6433C5.47923 26.2984 6.43361 29.923 8.42359 32.9994C9.23583 34.2583 8.87032 35.9336 7.61135 36.7458C6.37269 37.5378 4.73806 37.2027 3.90552 35.9945C-3.19142 25.3846 -0.34859 11.0283 10.2613 3.92119C12.2005 2.62161 14.3225 1.62665 16.5561 0.966702C21.257 -0.424257 26.2725 -0.312598 30.9125 1.29157H30.9226C32.5877 1.91091 33.4406 3.75876 32.8314 5.42385C32.2323 7.04833 30.4454 7.91133 28.8006 7.36307L28.7397 7.34278"
        fill="url(#paint2_linear_19627_4648)"
      />
      <path
        d="M34.5275 4.93677C34.5275 6.89646 32.9333 8.49061 30.9736 8.49061C29.0139 8.49061 27.4198 6.89646 27.4198 4.93677C27.4198 2.97708 29.0139 1.38293 30.9736 1.38293C32.9333 1.38293 34.5275 2.97708 34.5275 4.93677Z"
        fill="#262AFF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19627_4648"
          x1="11.847"
          y1="0.323761"
          x2="28.8391"
          y2="4.43128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3FA3DE" />
          <stop offset="1" stop-color="#3FA3DE" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19627_4648"
          x1="6.91793"
          y1="31.6274"
          x2="20.4511"
          y2="14.5055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#262AFF" />
          <stop offset="1" stop-color="#262AFF" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19627_4648"
          x1="7.39354"
          y1="16.408"
          x2="20.1052"
          y2="7.54436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#262AFF" stop-opacity="0.2" />
          <stop offset="1" stop-color="#262AFF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OneGPIconShort;
